import React from 'react';

interface PopoverArrowProps {
  className?: string;
  testId?: string;
}

export const PopoverArrow: React.FC<PopoverArrowProps> = ({
  testId,
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      data-testid={testId}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6L-2.03865e-07 0L12 0L6 6Z"
        fill="white"
      />
    </svg>
  );
};
